import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Create a default MUI theme
// You can customize this theme later if needed
const theme = createTheme({
  // You can add theme customizations here, e.g.:
  // palette: {
  //   primary: {
  //     main: '#1976d2', // Example primary color
  //   },
  //   secondary: {
  //     main: '#dc004e', // Example secondary color
  //   },
  // },
  // typography: {
  //   fontFamily: 'Roboto, Arial, sans-serif',
  // },
});

const AppThemeProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstarts an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
